import store from '@/store'

function authPermission (permission) {
  const allPermission = '*:*:*'

  // 1. 检查 store 是否存在
  if (!store) {
    console.error('Store is not defined')
    return false
  }

  // 2. 检查 getters 是否存在
  if (!store.getters) {
    console.error('Store getters is not defined')
    return false
  }

  // 3. 获取 permissions 并检查是否为数组
  const permissions = store.getters.permissions
  console.log('Current permissions:', permissions)

  // 4. 如果 permission 参数无效，直接返回 false
  if (!permission || typeof permission !== 'string' || permission.trim().length === 0) {
    return false
  }

  // 5. 如果 permissions 不存在或不是数组，返回 false
  if (!permissions || !Array.isArray(permissions)) {
    console.error('Permissions is not an array:', permissions)
    return false
  }

  // 6. 检查权限
  return permissions.some(v => {
    return allPermission === v || v === permission
  })
}

function authRole (role) {
  const superAdmin = 'admin'
  const roles = store.getters && store.getters.roles
  if (role && role.length > 0) {
    return roles.some(v => {
      return superAdmin === v || v === role
    })
  } else {
    return false
  }
}

export default {
  // 验证用户是否具备某权限
  hasPermi (permission) {
    return authPermission(permission)
  },
  // 验证用户是否含有指定权限，只需包含其中一个
  hasPermiOr (permissions) {
    if (!permissions || !Array.isArray(permissions) || permissions.length === 0) {
      return false
    }
    return permissions.some(item => {
      return authPermission(item)
    })
  },
  // 验证用户是否含有指定权限，必须全部拥有
  hasPermiAnd (permissions) {
    if (!permissions || !Array.isArray(permissions) || permissions.length === 0) {
      return false
    }
    return permissions.every(item => {
      return authPermission(item)
    })
  },
  // 验证用户是否具备某角色
  hasRole (role) {
    return authRole(role)
  },
  // 验证用户是否含有指定角色，只需包含其中一个
  hasRoleOr (roles) {
    if (!roles || !Array.isArray(roles) || roles.length === 0) {
      return false
    }
    return roles.some(item => {
      return authRole(item)
    })
  },
  // 验证用户是否含有指定角色，必须全部拥有
  hasRoleAnd (roles) {
    return roles.every(item => {
      return authRole(item)
    })
  }
}
